import React from 'react';
import {
  Box,
  Container,
  VStack,
} from '@chakra-ui/react';
import LoginForm from '../components/LoginForm';

const LoginView = ({ onLoginSubmit }) => {

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="center">
        <Box w="100%" maxW="400px">
          <LoginForm onSubmit={onLoginSubmit} />
        </Box>
      </VStack>
    </Container>
  );
};

export default LoginView;
